import { DynamicChip } from "./DynamicChip";
import { Link, ExternalLink } from "./Link";

/** Components, Utils etc, which is used by both the DynamicForm and the DynamicGrid */
export const DynamicShared = {
  Chip: DynamicChip,
  Link,
  ExternalLink,
};
